import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { dataPribadiKey } from "../../queries/DataPribadi/useFetchDataPribadi";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";

export async function addIjazah(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", file.name);
  const res = await ApiClient.post(`/Ijazah`, formData);
  return res.data;
}

export const useAddIjazah = mutationWrapper(addIjazah, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(dataPribadiKey);
    getQueryClient().invalidateQueries(checkProfileKey);
  },
});
